import ExpandableChartCard from "../../../../shared/charts/ExpandableChartCard";
import ComboChart, { toComboArrays } from "./ComboChart";

/**
 * Profit Margin % — Actual vs Forecast (restored to the legacy
 * ComboChart style per user request). Past months are bars with %
 * labels, future months are a dashed forecast line with soft fill,
 * target % renders as a horizontal dashed line.
 */
export default function ProfitMarginChart({ data, canSee, target }) {
  if (!canSee) return null;
  const { actual, forecast } = toComboArrays(data, "Actual", "Forecast");
  return (
    <ExpandableChartCard
      title="Profit Margin % — Actual vs Forecast"
      subtitle={`Blended profit margin · Target ${target}%`}
      renderChart={({ expanded }) => (
        <>
          <ComboChart
            actual={actual}
            forecast={forecast}
            target={Number(target) || 25}
            unit="%"
            label="margin"
            height={expanded ? 360 : 220}
            actualColor="#3b7ffa"
            forecastColor="#60a5fa"
            targetColor="#f59e0b"
          />
          <Legend />
        </>
      )}
    />
  );
}

function Legend() {
  return (
    <div className="flex items-center gap-4 mt-2 text-[11px] text-rc-text-secondary">
      <span className="inline-flex items-center gap-1.5"><span className="w-3 h-1 rounded-sm bg-[#3b7ffa]"/> Actual</span>
      <span className="inline-flex items-center gap-1.5"><span className="w-4 h-px border-t border-dashed border-[#60a5fa]"/> Forecast</span>
      <span className="inline-flex items-center gap-1.5"><span className="w-4 h-px border-t border-dashed border-[#f59e0b]"/> Target</span>
    </div>
  );
}
